/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleProvisioningControllerSyncStatusQueryResponse, TrimbleProvisioningControllerSyncStatus400, TrimbleProvisioningControllerSyncStatus401, TrimbleProvisioningControllerSyncStatus403, TrimbleProvisioningControllerSyncStatus404 } from "../../models/trimbleProvisioningController/TrimbleProvisioningControllerSyncStatus";

function getTrimbleProvisioningControllerSyncStatusUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble-provisioning-sync-status` as const }  
  return res
}

/**
 * @summary Health of the Trimble Event Service poll in this environment
 * {@link /api/v1/trimble-provisioning-sync-status}
 */
export async function trimbleProvisioningControllerSyncStatus(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleProvisioningControllerSyncStatusQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerSyncStatus400 | TrimbleProvisioningControllerSyncStatus401 | TrimbleProvisioningControllerSyncStatus403 | TrimbleProvisioningControllerSyncStatus404>, unknown>({ method : "GET", url : getTrimbleProvisioningControllerSyncStatusUrl().url.toString(), ... requestConfig })  
  return res.data
}